module.exports = __webpack_public_path__ + "static/img/loginNew_bg.50025e0e.jpg";